Array.prototype.remove = function (item) {
  const index = this.indexOf(item);
  if (index === -1) {
    console.warn('Can`t remove from array, item not found');
  } else {
    this.splice(index, 1)
  }
};
